import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { CatalogsComponent } from './components/catalogs/catalogs.component';
import { DefaultComponent } from './components/default/default.component';
import { GradesComponent } from './components/grades/grades.component';
import { LinesComponent } from './components/lines/lines.component';
import { LoginComponent } from './components/login/login.component';
import { OrderAdminComponent } from './components/order-admin/order-admin.component';
import { OrderFamilyComponent } from './components/order-family/order-family.component';
import { ProductsComponent } from './components/products/products.component';
import { RelationshipsComponent } from './components/relationships/relationships.component';
import { SchoolsComponent } from './components/schools/schools.component';
import { StagesComponent } from './components/stages/stages.component';
import { StudentPhotosComponent } from './components/student-photos/student-photos.component';
import { StudentsComponent } from './components/students/students.component';
import { TemplatesComponent } from './components/templates/templates.component';
import { UsersComponent } from './components/users/users.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { YearperiodsComponent } from './components/yearperiods/yearperiods.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ResponseOkComponent } from './components/redsys-response/response-ok/response-ok.component';
import { ResponseKoComponent } from './components/redsys-response/response-ko/response-ko.component';
import { ShoppingCartComponent } from './components/shopping-cart/shopping-cart.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { UploadStudentsComponent } from './components/upload-students/upload-students.component';
import { UploadImagesComponent } from './components/upload-images/upload-images.component';
import { SendNotificationsComponent } from './components/send-notifications/send-notifications.component';
import { RelationshipschoolusersComponent } from './components/relationshipschoolusers/relationshipschoolusers.component';
import { RelationshipuserschoolsComponent } from './components/relationshipuserschools/relationshipuserschools.component';
import { ReportagesComponent } from './components/reportages/reportages.component';
import { UploadReportageRelationshipsComponent } from './components/upload-reportage-relationships/upload-reportage-relationships.component';
import { RelationshipsUserReportagesComponent } from './components/relationships-user-reportages/relationships-user-reportages.component';
import { ReportagesPhotosComponent } from './components/reportages-photos/reportages-photos.component';
import { UploadReportageImagesComponent } from './components/upload-reportage-images/upload-reportage-images.component';
import { OrdersReportagesComponent } from './components/orders-reportages/orders-reportages.component';
import { ReportagePhotosDetailsComponent } from './components/reportage-photos-details/reportage-photos-details.component';
import { NoAccountComponent } from './components/login/no-account/no-account.component';
import { UnsubscribeUserComponent } from './components/unsubscribe-user/unsubscribe-user.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'new-account',
    component: NoAccountComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'unsubscribe-user',
    component: UnsubscribeUserComponent
  },
  {
    path: ':id/ok',
    component: ResponseOkComponent
  }, {
    path: ':id/ko',
    component: ResponseKoComponent
  }, {
    path: 'shopping-cart',
    component: ShoppingCartComponent
  },
  {
    path: '',
    component: DefaultComponent,
    data: { id: 'default' },
    children: [{
      path: '',
      component: UsersComponent
    }, {
      path: 'users',
      component: UsersComponent,
      data: { id: 0 }
    }, {
      path: 'user/:id',
      component: UsersComponent,
      data: { id: 0 }
    }, {
      path: 'templates',
      component: TemplatesComponent,
      data: { id: 1 }
    }, {
      path: 'template/:id',
      component: TemplatesComponent,
      data: { id: 1 }
    }, {
      path: 'template/:id/duplicate',
      component: TemplatesComponent,
      data: { id: 1 }
    }, {
      path: 'yearperiods',
      component: YearperiodsComponent,
      data: { id: 2 }
    }, {
      path: 'yearperiod/:id',
      component: YearperiodsComponent,
      data: { id: 2 }
    }, {
      path: 'catalogs',
      component: CatalogsComponent,
      data: { id: 3 }
    }, {
      path: 'catalogue/:id',
      component: CatalogsComponent,
      data: { id: 3 }
    }, {
      path: 'catalogue/:id/duplicate',
      component: CatalogsComponent,
      data: { id: 3 }
    }, {
      path: 'products',
      component: ProductsComponent,
      data: { id: 4 }
    }, {
      path: 'product/:id',
      component: ProductsComponent,
      data: { id: 4 }
    }, {
      path: 'product/:id/duplicate',
      component: ProductsComponent,
      data: { id: 4 }
    }, {
      path: 'schools',
      component: SchoolsComponent,
      data: { id: 5 }
    }, {
      path: 'school/:id',
      component: SchoolsComponent,
      data: { id: 5 }
    },{
      path: 'school/:id/:tabid',
      component: SchoolsComponent,
      data: { id: 5 }
    }, {
      path: 'reportages',
      component: ReportagesComponent,
      data: { id: 13 }
    }, {
      path: 'reportage/:id',
      component: ReportagesComponent,
      data: { id: 13 }
    },{
      path: 'reportage/:id/:action',
      component: ReportagesComponent,
      data: { id: 13 }
    },{
      path: 'reportage-details',
      component: ReportagePhotosDetailsComponent,
      data: { id: 15 }
    },{
      path: 'reportage-details/:id',
      component: ReportagePhotosDetailsComponent,
      data: { id: 15 }
    }, {
      path: 'reportage/:id/:tabid',
      component: ReportagesComponent,
      data: { id: 13 }
    }, {
      path: ':school_id/stage/:stage_id',
      component: StagesComponent,
      data: { id: 5 }
    }, {
      path: ':school_id/grade/:grade_id',
      component: GradesComponent,
      data: { id: 5 }
    }, {
      path: ':school_id/line/:line_id',
      component: LinesComponent,
      data: { id: 5 }
    }, {
      path: 'studentphotos',
      component: StudentPhotosComponent,
      data: { id: 6 }
    }, {
      path: 'studentphoto/:id',
      component: StudentPhotosComponent,
      data: { id: 6 }
    }, {
      path: ':user_id/relationship/:relationship_id',
      component: RelationshipsComponent,
      data: { id: 0 }
    }, {
      path: ':user_id/relationshipuserschools/:relationship_id',
      component: RelationshipuserschoolsComponent,
      data: { id: 0 }
    },{
      path: ':user_id/relationshipuserreportages/:relationship_id',
      component: RelationshipsUserReportagesComponent,
      data: { id: 0 }
    },{
      path: ':user_id/relationshipschoolusers/:relationship_id',
      component: RelationshipschoolusersComponent,
      data: { id: 5 }
    }, {
      path: 'student/:relationship_id',
      component: StudentsComponent,
      data: { id: 8 }
    },{
      path: 'reportagephoto/:reportage_id',
      component: ReportagesPhotosComponent,
      data: { id: 8 }
    }, {
      path: 'orders',
      component: OrderFamilyComponent,
      data: { id: 9 }
    }, {
      path: 'order/:reference',
      component: OrderFamilyComponent,
      data: { id: 9 }
    }, {
      path: 'orders-admin',
      component: OrderAdminComponent,
      data: { id: 10 }
    }, {
      path: 'orders-reportages',
      component: OrdersReportagesComponent,
      data: { id: 14 }
    }, {
      path: 'order-reportage/:reference/:id_reportage',
      component: OrdersReportagesComponent,
      data: { id: 14 }
    },{
      path: 'order-admin/:reference/:id_student',
      component: OrderAdminComponent,
      data: { id: 10 }
    }, {
      path: 'welcome',
      component: WelcomeComponent,
      data: { id: 11 }
    }, {
      path: 'how-it-works',
      component: HowItWorksComponent,
      data: { id: 12 }
    }, {
      path: 'upload-students/:id_school',
      component: UploadStudentsComponent,
      data: { id: 5 }
    },{
      path: 'upload-reportage-relationships/:id_reportage',
      component: UploadReportageRelationshipsComponent,
      data: { id: 13 }
    }, {
      path: 'send-notifications/school/:id_school',
      component: SendNotificationsComponent,
      data: { id: 5 }
    },{
      path: 'process-orders/school/:id_school_orders',
      component: SendNotificationsComponent,
      data: { id: 5 }
    }, {
      path: 'send-notifications/reportage/:id_reportage',
      component: SendNotificationsComponent,
      data: { id: 13 }
    },{
      path: 'upload-images/:id_school',
      component: UploadImagesComponent,
      data: { id: 5 }
    },{
      path: 'upload-reportage-images/:id_reportage',
      component: UploadReportageImagesComponent,
      data: { id: 13 }
    },
    ],
    canActivate: [AuthGuard]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
